module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image11.56bc4fbc.webp";